import React, { Component, Fragment } from 'react'
import cn from 'classnames'
import get from 'lodash/get'
import { withTranslation } from 'react-i18next'

import PropTypes from 'prop-types'
import Popover from 'react-popover'
import ArrowUpIcon from 'app/components/SVGS/ArrowUpIcon'

import './styles.scss'
const bc = 'feed-story'

const MAX_LENGTH = 97

class FeedStory extends Component {
  state = {
    collapsedText: true,
    collapsedQuote: true,
    showTooltip: false,
  }

  onToggleCollapseText = () => {
    this.setState({ collapsedText: !this.state.collapsedText })
  }

  onToggleCollapseQuote = () => {
    this.setState({ collapsedQuote: !this.state.collapsedQuote })
  }

  onShowTooltip = () => {
    const { activity, onLoadStoryActivity } = this.props
    // TODO: @serginyo90 bad solution. UI must recieve full data from server
    if (!activity.name) {
      onLoadStoryActivity()
    }

    this.setState({ showTooltip: !this.state.showTooltip })
  }

  renderActivity = () => {
    const { name, description, proQuote, proQuoteAuthor, proTrackLevel } = this.props.activity
    const { t } = this.props
    const { collapsedQuote } = this.state
    if (!name) {
      return ''
    }

    const proTrackPublicName = get(proTrackLevel, 'proTrack.publicProTrack.name', proTrackLevel.proTrack.name)

    return (
      <div className={`${bc}__activity`}>
        <div className={`${bc}__protrack`}>{`${proTrackPublicName} (Level ${proTrackLevel.order})`}</div>
        <div className={`${bc}__name`}>{name}</div>
        <div className={`${bc}__description`} dangerouslySetInnerHTML={{ __html: description }} />
        {proQuote ? (
          <Fragment>
            <div className={`${bc}__collapse-quote`}>
              <div className={`${bc}__collapse-button`} onClick={this.onToggleCollapseQuote}>
                {t('View quote')}
                <span className={cn(`${bc}__collapse-icon`, { [`--up`]: !collapsedQuote })} />
              </div>
            </div>
            {!collapsedQuote ? (
              <Fragment>
                <div className={`${bc}__quote`}>{proQuote}</div>
                {proQuoteAuthor && <div className={`${bc}__author`}>— {proQuoteAuthor}</div>}
              </Fragment>
            ) : null}
          </Fragment>
        ) : null}
      </div>
    )
  }

  render() {
    const { t, story, activity } = this.props
    const { collapsedText, showTooltip } = this.state
    const outOfLimit = story.length >= MAX_LENGTH
    const text = collapsedText && outOfLimit ? `${story.substr(0, MAX_LENGTH)}...` : story

    return (
      <div className={bc}>
        <div className={`${bc}__title`}>
          {activity.question}
          <Popover
            isOpen={showTooltip && activity.name !== ''}
            preferPlace="below"
            place={null}
            tipSize={7}
            body={this.renderActivity()}
            onOuterAction={() => {
              this.setState({ showTooltip: false })
            }}
          >
            <div className={cn(`${bc}__tooltip-icon`, { [`--up`]: showTooltip })} onClick={this.onShowTooltip}>
              <ArrowUpIcon />
            </div>
          </Popover>
        </div>
        <span className={`${bc}__text`} dangerouslySetInnerHTML={{ __html: text }} />
        {outOfLimit ? (
          <span className={`${bc}__collapse`} onClick={this.onToggleCollapseText}>
            {collapsedText ? t(' Read more') : t(' View less')}
          </span>
        ) : null}
      </div>
    )
  }
}

FeedStory.propTypes = {
  story: PropTypes.string.isRequired,
  activity: PropTypes.object.isRequired,
  onLoadStoryActivity: PropTypes.func.isRequired,
}

export default withTranslation('user')(FeedStory)
